import styled from 'styled-components'

export const BtnRemoveReferencia = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: fit-content;
  gap: 0.8rem;

  & .icon {
    font-size: 1.2rem;
    color: red;
  }
`
